<template>

      <div style="left:0;" id="kt_subheader" class="subheader py-2 py-lg-4"
              v-bind:class="subheaderClasses">
        <div class="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap"
                v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }">
          <div class="d-flex align-items-center flex-wrap mr-1">
            <ul class="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold p-0 my-2">
              <li v-if="projectObject && projectObject.name" >
                  <router-link :to="'/'"/>
                  <span class="text-muted" style="">
                    {{projectObject.name}}
                  </span>
                  <span class="h5 mb-2" v-if="breadcrumbs.length > 0">
                    <b-icon icon="chevron-double-right" class="ml-1 mr-2"/>
                  </span>
              </li>
              <template v-for="(breadcrumb, i) in breadcrumbs">
                <!-- 아래에서 breadcrumb-item 클래스 생략 -->
                <li class="d-flex align-items-center" :key="`${i}-${breadcrumb.id}`">
                  <router-link v-if="breadcrumb.route" :key="i" :to="breadcrumb.route" class="text-muted">
                    {{ breadcrumb.title }}
                  </router-link>
                  <span class="text-muted ellipsis" style="font-weight: bold; color:#6e6e6e !important;" :key="i" v-if="!breadcrumb.route">
                    {{ breadcrumb.title }}
                  </span>
                  <span class="h5 d-flex align-items-center" v-show="i!==( breadcrumbs.length - 1 )" style="margin: 0">
                    <b-icon icon="chevron-double-right" class="ml-1 mr-2"/>
                  </span>
                </li>
              </template>
            </ul>
          </div>

          <div
              class="font-weight-bolder"
              style="display: flex; align-items: center; justify-content: flex-end;">

            <b-dropdown id="dropdown-1" :text="selected" class="" variant="newcolor" size="sm"
                        :menu-class="['custom-dropdown']">
              <b-dropdown-item class="dropdown-item p-0" v-for="item in languageList" @click="selectLanguage( item )" v-bind:key="item.code">
                {{item.name}}
              </b-dropdown-item>
            </b-dropdown>

          </div>

        </div>
      </div>

</template>

<script>
import { mapGetters } from "vuex";
import LanguageList from "/src/core/config/languageObject.json";


export default {
  name: "KTSubheader",
  props: {
    breadcrumbs: Array,
    title: String
  },
  data() {
    return {
      selected: "English"
    };
  },
  methods: {
    selectLanguage ( item ) {
      this.$i18n.locale=item.code;
      this.selected = item.name;
    },
  },
  mounted() {

    this.selected = this.$i18n.locale === "en" ? "English" : "한국어";

  },
  computed: {
    ...mapGetters(["layoutConfig"]),
    languageList () {

      let processingList = Object.entries(LanguageList).map((e) => ( e[1] ));
      return processingList.filter( language => language.status );
    },
    projectObject() {
      return this.$store.getters.getSelectedProjectObject;
      // return this.$session.get( this.$store.state.sessionKey.PROJECT_OBJECT );
    },

    /**
     * Check if subheader width is fluid
     */
    widthFluid() {
      return this.layoutConfig("subheader.width") === "fluid";
    },

    subheaderClasses() {
      const classes = [];
      const style = this.layoutConfig("subheader.style");
      if (style) {
        classes.push(style);

        if (style === "solid") {
          classes.push("bg-white");
        }

        if (this.layoutConfig("subheader.fixed")) {
          classes.push("border-top");
        }
      }
      return classes.join(" ");
    }
  }
};
</script>

<style lang="scss">

  .ellipsis {
    display: block;
    white-space: nowrap;
    overflow : hidden;
    text-overflow: ellipsis;
  }

  .breadcrumb-item {
    display: flex;
  }
  .custom-v-dropdown {
    &.dropdown-toggle {
      padding: 0;
      &:hover {
        text-decoration: none;
      }

      &.dropdown-toggle-no-caret {
        &:after {
          content: none;
        }
      }
    }

    &.dropdown-menu {
      margin: 0;
      padding: 0;
      outline: none;
      .b-dropdown-text {
        padding: 0;
      }
    }
}
</style>
